<div class="main">
  <!-- 

    <section class="breadcrump-internal">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <h5>Home / {{title()}}</h5>
                </div>
            </div>
        </div>
    </section> -->

  <!-- tabing-code-start -->
  <section class="internal-data-change-tabing" [class.actveShow]="isToggled">
    <!--- this class add  actveShow-->
    <div class="tav-title-internaldatanav" [class.scrolled]="isScrolled">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <ul
              class="nav main-menu justify-content-center justify-content-md-start justify-content-lg-center justify-content-xl-center"
            >
          <ng-container *ngFor="let item of menuItems; let i = index">
                <li
                  class="nav-item dropdown"
                  *ngIf="roleService.canView(item.accessUrl)"
                    [attr.id]="'menu-item-' + i"
                >
                  <a
                    class="nav-link group-label"
                    [ngClass]="{ 'dropdown-toggle': item.subGroups }"
                    [attr.data-bs-toggle]="item.subGroups ? 'dropdown' : null"
                    href="#"
                    role="button"
                    aria-expanded="false"
                    [routerLink]="item.route"
                    routerLinkActive="active"
                  >
                    {{ item.label }}
                  </a>
                  <div class="dropdown-menu megadrop" *ngIf="item.subGroups">
                    <div class="menu-columns">
                      <!-- Parent Modules Column -->
                      <div class="parent-modules">
                        <ng-container
                          *ngFor="let subGroup of item.subGroups; let i = index"
                        >
                          <div
                            class="parent-module"
                            [class.active]="selectedParentIndex === i"
                            (mouseenter)="selectedParentIndex = i"
                            *ngIf="subGroup.items && subGroup.items.length"
                          >
                            <div class="module-title">
                              <span>{{ subGroup.label }}</span>
                              <i class="fas fa-chevron-right"></i>
                            </div>
                          </div>
                        </ng-container>
                      </div>

                      <!-- Child Modules Column -->
                      <div
                        class="child-modules"
                        *ngIf="
                          selectedParentIndex > -1 &&
                          item.subGroups[selectedParentIndex]
                        "
                      >
                        <div
                          class="menu-group"
                          [ngClass]="{
                            'menu-group-master': item.label === 'MASTERS',
                            'menu-group-transaction':
                              item.label === 'Transaction',
                            'menu-group-report': item.label === 'Reports',
                            'menu-group-delivery':
                              item.label === 'Delivery Challan',
                            'menu-group-finance': item.label === 'Finance',
                          }"
                        >
                          <div class="menu-group-title">
                            {{ item.subGroups[selectedParentIndex].label }}
                          </div>
                          <ul>
                            <ng-container
                              *ngFor="
                                let subItem of item.subGroups[
                                  selectedParentIndex
                                ].items
                              "
                            >
                              <li
                                *ngIf="roleService.canView(subItem.accessUrl)"
                              >
                                <a [routerLink]="subItem.route">{{
                                  subItem.label
                                }}</a>
                              </li>
                            </ng-container>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="tab-content" id="myTabContent">
      <div
        class="tab-pane fade show active"
        id="dashboard"
        role="tabpanel"
        aria-labelledby="dashboard-tab"
      >
        <div class="container" *ngIf="title() != 'Welcome'">
          <div class="title-tav-inner-section">
            <h3>{{ title() }}</h3>
          </div>
        </div>

        <router-outlet></router-outlet>
      </div>
    </div>
  </section>
</div>
